import api from './api';

export const getPartners = (page, params) => {
  return api.get('admin/Partners', { params: { page: page, limit: 5, ...params } });
};

export const getPartner = id => {
  return api.get(`admin/Partners`, { params: { searchItem: 'id', search: id } });
};

export const createPartner = data => {
  return api.post('admin/partner/create', data);
};

export const updatePartner = (id, data) => {
  return api.put(`admin/partner/update/${id}`, data);
};

export const removePartner = id => {
  return api.delete(`admin/partner/delete/${id}`);
};
